var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help",staticStyle:{"margin-top":"80px"}},[_c('page-6')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }